<template>
  <v-autocomplete
    :items="items"
    v-model="selectedRateType"
    :label="label"
    item-text="label"
    item-value="code"
    @change="changeListener($event)"
    :outlined="outlined"
    :disabled="disabled"
    :hide-details="hideDetails"
  ></v-autocomplete>
</template>

<script>
import { ALL_RATE_TYPES_SEARCH_QUERY } from "../../../constants/graphql";
import { removeGQLTypename } from "../../../helpers";

export default {
  name: "RateTypeListSelect",

  props: {
    customLabel: { type: String },
    value: { type: String, default: () => "" },
    rateTypeCode: { type: String },
    hideNotInUse: {
      type: Boolean,
      default: () => false,
    },
    outlined: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    hideDetails: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      rateTypes: {},
      rateTypesList: [],
      selectedRateType: this.value ? this.value : "",
    };
  },

  methods: {
    changeListener(data) {
      if (typeof data === "string") {
        const selectedRateType = this.rateTypesList.find(
          (r) => r.code === data
        );
        if (selectedRateType) {
          this.$emit("onSelect", selectedRateType);
        }
        this.$emit("input", data);
      }
    },
  },

  computed: {
    label() {
      return this.customLabel ? this.customLabel : "Rate Type";
    },
    items() {
      const list =
        this.rateTypes && this.rateTypes.edges
          ? this.rateTypes.edges.map(removeGQLTypename).map((item) => ({
              ...item,
              label: `${item.name} (${item.code})`,
            }))
          : [];
      return this.hideNotInUse
        ? list.filter((r) => r.code == this.value || !r.notInUse)
        : list;
    },
  },

  watch: {
    rateTypeCode: {
      immediate: true,
      handler(code) {
        if (code) {
          this.selectedRateType = code;
          const selectedRateType = this.rateTypesList.find(
            (r) => r.code == this.selectedRateType
          );
          if (selectedRateType) {
            this.$emit("onSelect", selectedRateType);
          }
        }
      },
    },
    value(code) {
      this.selectedRateType = code;

      const selectedRateType = this.rateTypesList.find(
        (r) => r.code == this.selectedRateType
      );
      if (selectedRateType) {
        //this.selectedRateType = selectedRateType;
        this.$emit("onSelect", selectedRateType);
      }
    },
  },

  apollo: {
    rateTypes: {
      query: ALL_RATE_TYPES_SEARCH_QUERY,
      variables() {
        return {};
      },
      result({ data, loader, networkStatus }) {
        this.rateTypesList = data.rateTypes.edges.map((rt) => ({ ...rt.node }));
        const selectedRateType = this.rateTypesList.find(
          (r) => r.code == this.selectedRateType
        );
        if (selectedRateType) {
          this.$emit("onSelect", selectedRateType);
        }
      },
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/gt/shared/RateTypeListSelect.vue